<template>
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
      <div
        class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
      >
        <div class="d-sm-flex align-items-center">
          <router-link
            class="btn btn-primary"
            to="/ajouter-usager"
          >
            <i class="fa fa-plus-circle"></i>
            Ajouter un marchand
          </router-link>
        </div>
        <div class="d-flex align-items-center">
        <form class="search-box position-relative me-15" @submit.prevent="rechercher">
          <input type="text" v-model="searchTerm" @keyup="rechercher"
            class="form-control shadow-none text-black rounded-0 border-0" placeholder="Rechercher un marchand" />
          <button type="submit" class="bg-transparent text-primary transition p-0 border-0">
            <i class="flaticon-search-interface-symbol"></i>
          </button>
        </form>
      </div>
      </div>
      <div class="card-body p-15 p-sm-20 p-md-25">
        <div class="table-responsive">
          <table class="table text-nowrap align-middle mb-0">
            <thead>
              <tr>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                 Nom Complet
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                 Raison Sociale
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                 Email
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                 Telephone
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                 Matricule
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                 NPI
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                 IFU
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0  pe-0"
                >ACTIONS</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(usager, index) in usagers" :key="index">
                <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  {{ usager.nom ? (usager.nom + " " + usager.prenom) : usager.raisonSocial }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  {{ usager.raisonSocial }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  {{ usager.email }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  {{ usager.numtel }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  {{ usager.matricule }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  {{ usager.npi }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  {{ usager.ifu }}
                </td>
                <td
                  class="shadow-none lh-1 fw-medium text-body-tertiary pe-0"
                >
                <div class="shadow-none lh-1 fw-medium text-black pe-0 text-end">
                  <button class="btn btn-sm btn-primary" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    Actions
                  </button>
                    <ul class="dropdown-menu">
                      <li >
                        <router-link :to="{ name: 'EditUsagerPage', params: { id:usager.id } }" 
                            class="dropdown-item d-flex align-items-center"><i
                            class="flaticon-pen lh-1 me-8 position-relative top-1"
                          ></i>Modifier</router-link>
                      </li>
                      <li class="dropdown-item d-flex align-items-center">
                            <router-link
                              :to="{ name: 'ViewUsagerPage',params: { id: usager.id } }"
                            >
                              <i class="flaticon-pen lh-1 me-8 position-relative top-1"></i>
                              Détails
                            </router-link>
                          </li>
                      <li>
                        <a
                          class="dropdown-item d-flex align-items-center" href="javascript:void(0);" @click="suppression(usager.id,usagers,'usagers',`Usager ${usager.id}`)">
                          <i class="flaticon-delete lh-1 me-8 position-relative top-1" ></i>
                           Supprimer
                        </a>
                      </li>
                    </ul>
                </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center"
        >
          <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit" @paginate="handlePaginate" />
        </div>
      </div>
    </div>
  </template>
  
  <script lang="ts">
  import { defineComponent, onMounted, ref} from "vue";
  import Swal from "sweetalert2";
  import { Usager } from "@/models/Usager";
  import ApiService from "@/services/ApiService";
  import { suppression, error } from "@/utils/utils";
  import PaginationComponent from '@/components/Utilities/Pagination.vue';
  import JwtService from "@/services/JwtService";
import { removeKkiapayListener } from 'kkiapay';
  
  export default defineComponent({
    name: "ListeUsager",
    components: {
      PaginationComponent
    },
    setup(){
      
      onMounted(() => {
        getAllUsagers();
      });
  
      const usagers = ref<Array<Usager>>([]);   
      const usager = ref<Usager>();
        const searchTerm = ref('');
      const page = ref(1);
      const totalPages = ref(0);
      const limit = ref(10);
      const totalElements = ref(0);
  
      const handlePaginate = ({ page_, limit_ }) => {
        try {
          page.value = page_;
          getAllUsagers(page_, limit_);
        } catch (error) {
          //
        }
      };
  
       function rechercher(){
        getAllUsagers(page.value, limit.value, searchTerm.value );
      }

      function getAllUsagers(page = 1, limi = 10, searchTerm = '') {
        return ApiService.get(`/all/usagers?page=${page}&limit=${limi}&mot=${searchTerm}&`)
          .then(({ data }) => {
            usagers.value = data.data.data;
            totalPages.value = data.data.totalPages;
            limit.value = data.data.limit;
            totalElements.value = data.data.totalElements;
            return data.data;
          })
          .catch(({ response }) => {
            error(response.data.message)
        });
        
      }
      
      function moddifier(Editusagers:Usager) {
        usager.value = Editusagers;
      }
  
      const deleteUsager = (id: number) => {
        ApiService.delete(`/usagers/${id}`)
        .then(({ data }) => {
          Swal.fire({
            text: data.message,
            toast: true,
            icon: 'success',
            title: 'General Title',
            animation: false,
            position: 'top-right',
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
            heightAuto: false
          });
        })
        .catch(({ response }) => {
          Swal.fire({
            text: response.data.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Réssayer à nouveau!",
            heightAuto: false,
            customClass: {
              confirmButton: "btn fw-semobold btn-light-danger",
            },
          });
        });
  
        for(let i = 0; i < usagers.value.length; i++) {
          if (usagers.value[i].id === id) {
             usagers.value.splice(i, 1);
          }
        }
      };
  
      const privileges = ref<Array<string>>(JwtService.getPrivilege());
  
      const checkPermission = (name) => {
        return privileges.value.includes(name);
      }
  
      
      return { usagers,
        checkPermission,
       getAllUsagers,
       deleteUsager,
       moddifier ,
       suppression,
       page, 
      totalPages,
      limit,
      totalElements,
      handlePaginate,
      rechercher,
      searchTerm,

    };
    },
  });
  </script>